import { get, post } from '../request';
import { toPage, type Page, type PageQuery } from './types';

/**
 * 服务小结（/call-summaries）：挂断后坐席填写，与 CDR 一对一（upsert 语义）。
 */
export interface CallSummary {
  id?: number;
  cdr_id: number;
  category: string;
  result: string;
  note?: string;
  follow_up?: boolean;
  agent_id?: number;
  agent_name?: string;
  /** manual=人工填写 / ai=AI 生成草稿 */
  source?: string;
  draft?: boolean;
  status?: string;
  tags?: string;
  created_at?: string;
  updated_at?: string;
  [k: string]: any;
}

export const SUMMARY_CATEGORY_OPTIONS = ['咨询', '投诉', '售后', '业务办理', '其他'];

export const SUMMARY_RESULT_OPTIONS = ['已解决', '待回访', '未解决', '转人工跟进'];

export interface CallSummaryQuery extends PageQuery {
  cdr_id?: number;
  agent_id?: number;
}

/** GET /call-summaries */
export async function listCallSummaries(q: CallSummaryQuery): Promise<Page<CallSummary>> {
  return toPage<CallSummary>(await get('/call-summaries', q));
}

/** POST /call-summaries（upsert：同一 cdr_id 重复提交为更新） */
export function upsertCallSummary(v: {
  cdr_id: number;
  category: string;
  result: string;
  note?: string;
  follow_up?: boolean;
  /** AI 建议标签（JSON 数组字符串）；提交时携带即更新，空串表示不修改（保留原标签） */
  tags?: string;
}) {
  return post('/call-summaries', v);
}
